import SEO from "@/components/SEO";
import { PageHero, Reveal, LegalText } from "@/components/Bits";
import { PRODUCT_ORDER_TXT } from "@/content/policies";

export default function ProductOrderTerms() {
  return (
    <div data-testid="product-order-terms-page">
      <SEO
        title="Product Order & Delivery Terms"
        description="Terms for product orders on the Middle Man marketplace — seller acceptance, direct payment, address privacy, delivery inspection and returns."
        path="/product-order-terms"
      />
      <PageHero
        kicker="Legal"
        title="Product Order & Delivery Terms"
        subtitle="Effective from: 11 September 2026 · Applies to product marketplace orders placed through Middle Man."
      />
      <div className="mx-auto max-w-3xl px-6 py-16 md:py-20">
        <Reveal>
          <LegalText text={PRODUCT_ORDER_TXT} />
        </Reveal>
      </div>
    </div>
  );
}
